module.exports = __webpack_public_path__ + "static/media/HomeIconLight.0508c771.svg";